import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.regexp.replace";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CoreFeatureFlag',
  props: {
    flag: {
      default: '',
      required: true,
      type: String
    },
    inactive: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    enabled: function enabled() {
      var flagName = this.flag.replace(/^!/, '');

      if (this.flag.startsWith('!') || this.inactive) {
        return this.$store.state.app.featureFlags[flagName] !== true;
      }

      return this.$store.state.app.featureFlags[flagName] === true;
    }
  },
  render: function render() {
    return this.enabled ? this.$slots.default : null;
  }
};